// @flow

import { Wrapper } from "./Tag.styles.js";
import React, { type ChildrenArray } from "react";

type Props = {|
	type: string,
	light?: boolean,
	children: ChildrenArray<*>,
|};

const Tag = ({ type = "disabled", light, children }: Props) => (
	<Wrapper type={type} light={light}>
		{children}
	</Wrapper>
);

export default Tag;
